import React from 'react';
import { InventoryStockMovementSummaryCounts } from '@/renderer/types/inventory';
import { formatReportMoney } from '@/renderer/util/reporting';

export function StockMovementsSummaryCards({
  summary,
}: {
  summary: InventoryStockMovementSummaryCounts;
}) {
  const cards = [
    { label: 'Movement rows', value: summary.totalMovements.toLocaleString() },
    {
      label: 'Quantity in',
      value: summary.totalQuantityIn.toLocaleString(undefined, {
        maximumFractionDigits: 4,
      }),
    },
    {
      label: 'Quantity out',
      value: summary.totalQuantityOut.toLocaleString(undefined, {
        maximumFractionDigits: 4,
      }),
    },
    {
      label: 'Movement value',
      value: formatReportMoney(summary.totalMovementValue),
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.label}
          className="rounded-2xl border border-gray-200 bg-white px-4 py-4 shadow-sm"
        >
          <p className="text-sm text-gray-500">{card.label}</p>
          <p className="mt-2 text-2xl font-semibold text-gray-900">
            {card.value}
          </p>
        </div>
      ))}
    </div>
  );
}
